import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { CategoryCardV1 as CategoryCard } from '../../CategoryCard';

import { imgSizes } from './constants';

const Card = (props) => {

    const {
        loading,
        index,
        category,
        imageTemplateUrl,
        count,
        link,
        onClick,
    } = props;

    const handleClick = useCallback((event) => {

        onClick(event, category, index);

    }, [
        onClick,
        category,
        index,
    ]);

    if (loading) {

        return <CategoryCard loading />;

    }

    return (
        <CategoryCard
            as={Link}
            to={link}
            category={category}
            imageTemplateUrl={imageTemplateUrl}
            imgSizes={imgSizes}
            count={count}
            onClick={handleClick}
        />
    );

};

Card.propTypes = {
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    link: PropTypes.string,
    category: PropTypes.string,
    imageTemplateUrl: PropTypes.string,
    count: PropTypes.number,
    loading: PropTypes.bool,
};

Card.defaultProps = {
    loading: false,
};

export default Card;
